import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import ElectricianImg1 from '../../assest/Electronics-1.jpeg';
import ElectricianImg2 from '../../assest/electrician.png';
import ElectricianImg3 from '../../assest/electronics-3.png';

const ElectriciansList = [
  {
    name: "Residential Electrician",
    image: ElectricianImg1,
    specs: "Wiring, repairs, and installations for homes.",
    description: "Skilled in handling domestic electrical systems including lighting, appliances, and circuits.",
  },
  {
    name: "Commercial Electrician",
    image: ElectricianImg2,
    specs: "Electrical services for offices and businesses.",
    description: "Experienced with larger systems and ensuring code compliance for safety and efficiency.",
  },
  {
    name: "Industrial Electrician",
    image: ElectricianImg3,
    specs: "High-voltage and heavy machinery setups.",
    description: "Specialized in complex industrial equipment and automated systems in factories.",
  },
];

const translations = {
  gb: {
    heading: "Electrician Services",
    introText: "Explore our professional electrician services for every type of project or facility.",
    categoriesTitle: "Available Services",
    featuredTitle: "Top Electricians",
    featuredDescription: "Our most experienced electricians ready to tackle your toughest electrical jobs.",
  },
  sa: {
    heading: "خدمات الكهرباء",
    introText: "استكشف خدماتنا الاحترافية في الكهرباء لجميع أنواع المشاريع أو المنشآت.",
    categoriesTitle: "الخدمات المتاحة",
    featuredTitle: "أفضل الكهربائيين",
    featuredDescription: "أكثر الكهربائيين خبرة لدينا جاهزون لمعالجة أصعب المهام الكهربائية.",
  },
};

const Electricians = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={ElectriciansList}
      language={language}
    />
  );
};

export default Electricians;
